import { validate } from '@fingermarkglobal/validation';

const registerSuccess = ({ path } = {}) => async () => {
  try {
    const registration = await window.navigator.serviceWorker.register(path);
    logger.debug(
      'service-worker - registerSuccess - registration successful with scope: ',
      registration.scope,
    );
  } catch (err) {
    logger.error('service-worker - registerSuccess - error:', err);
  }
};

const registerError = err => logger.error('service-worker - registerError - error: ', err);

const register = ({ path = null } = {}) => {
  validate({ name: 'Service Worker Registration', parameter: { path } });

  if (!('serviceWorker' in window.navigator)) return;

  window.addEventListener('load', registerSuccess({ path }), registerError);
};

export { register };
